module.exports = __webpack_public_path__ + "img/login-bg2.d1a8948a.jpg";